import React, { PropsWithChildren } from 'react';
import type { ReactElement } from 'react';
import classNames from 'classnames';
import { getUniqueId } from '@micro-apps/env';

export interface Option {
	value: string;
	label: string;
}

export type Props = {
	options?: Option[];
	label?: string;
	name: string;
	value?: string;
	onChange?: React.ChangeEventHandler<HTMLSelectElement>;
	className?: string;
};

export default function Dropdown({
	label = '',
	children,
	name,
	value,
	options,
	onChange,
	className = '',
}: PropsWithChildren<Props>): ReactElement {
	const id = `${getUniqueId()}-React-Dropdown-${name}`;
	return (
		<div className={classNames('Dropdown minimal', className)}>
			<select
				className="Dropdown-field formElement-field formElement-field--filled formElement-field--valid Dropdown-field--changed Dropdown-field--filled ty-c4"
				name={name}
				id={id}
				value={value}
				onChange={onChange}
			>
				{options &&
					options.length &&
					options.map(option => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				{children}
			</select>
			<div className="Dropdown-labelContainer">
				<label className="formElement-label ty-c4" htmlFor={id}>
					{label}
				</label>
			</div>
		</div>
	);
}
